export default __webpack_public_path__ + "static/media/ktcl_02.87f7f017.png";